import { render, staticRenderFns } from "./AppoinmentCoordination.vue?vue&type=template&id=adbab938"
import script from "./AppoinmentCoordination.vue?vue&type=script&lang=js"
export * from "./AppoinmentCoordination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports